module.exports = __webpack_public_path__ + "static/monei_pay_group_es_1-b64b62e672b5603ddfe9bd4292923513.png";